import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

export const getStockCams = async () => {
  try {
    const response = await axios.get(`${API_BASE}/api/camHardware/getall`);
    return response.data;
  } catch (error) {
    console.error('Error fetching stock cams:', error);
    throw error;
  }
};

export const getStockCam = async (id) => {
  try {
    const response = await axios.get(`${API_BASE}api/camHardware/get/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching stock cam:', error);
    throw error;
  }
};

export const createStockCam = async (data) => {
  try {
    const response = await axios.post(`${API_BASE}/api/camHardware/create`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating stock cam:', error);
    throw error;
  }
};

export const updateStockCam = async (id, data) => {
  try {
    const response = await axios.put(`${API_BASE}/api/camHardware/update/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating stock cam:', error);
    throw error;
  }
};

export const deleteStockCam = async (id) => {
  try {
    await axios.delete(`${API_BASE}/api/camHardware/delete/${id}`);
  } catch (error) {
    console.error('Error deleting stock cam:', error);
    throw error;
  }
};


export const cleanStockCams = async (id) => {
  try {
    await axios.put(`${API_BASE}/api/camHardware/deletecamarainfo/${id}`);
  } catch (error) {
    console.error('Error cleaning stock cams:', error);
    throw error;
  }
};

